import React, { createContext, useState, useContext, useEffect } from 'react';
import { normalizePhone } from '../utils/phoneUtils';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Check for existing token on mount
  useEffect(() => {
    const storedToken = localStorage.getItem('authToken');
    const storedPhone = localStorage.getItem('phoneNumber');
    
    if (storedToken && storedPhone) {
      // Normalize phone number when loading from storage
      const normalizedPhone = normalizePhone(storedPhone) || storedPhone;
      setToken(storedToken);
      setUser({ phoneNumber: normalizedPhone });
      // Update storage with normalized phone if different
      if (normalizedPhone !== storedPhone) {
        localStorage.setItem('phoneNumber', normalizedPhone);
      }
    }
    
    setIsLoading(false);
  }, []);

  const login = (authToken, phoneNumber) => {
    // Normalize phone number before storing
    const normalizedPhone = normalizePhone(phoneNumber) || phoneNumber;
    localStorage.setItem('authToken', authToken);
    localStorage.setItem('phoneNumber', normalizedPhone);
    setToken(authToken);
    setUser({ phoneNumber: normalizedPhone });
  };

  const logout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('phoneNumber');
    setToken(null);
    setUser(null);
  };

  const isAuthenticated = () => {
    return !!token && !!user;
  };

  const value = {
    user,
    token,
    isLoading,
    login,
    logout,
    isAuthenticated: isAuthenticated()
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
